<template>
  <div> 
    <v-app>
      <AppHeader />
      <router-view style="padding-top: 1px !important"> </router-view>
      <AppTop />
      <AppFooter />
    </v-app>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld';
import AppHeader from "./components/Common/appHeader";
import AppFooter from "./components/Common/appFooter";
import AppTop from "./components/Common/appTop";

export default {
  name: "App",

  components: {
    // HelloWorld,
    AppHeader,
    AppFooter,
    AppTop,
  },

  data: () => ({
    //
  }),
};
</script>
<style>
@font-face {
  font-family: poppinslight;
  src: url("./assets/fonts/poppinslight.ttf");
}
@font-face {
  font-family: poppinsregular;
  src: url("./assets/fonts/poppinsregular.ttf");
}
@font-face {
  font-family: poppinsmedium;
  src: url("./assets/fonts/poppinsmedium.ttf");
}
@font-face {
  font-family: poppinssemibold;
  src: url("./assets/fonts/poppinssemibold.ttf");
}
@font-face {
  font-family: poppinsbold;
  src: url("./assets/fonts/poppinsbold.ttf");
}
@font-face {
  font-family: poppinsextrabold;
  src: url("./assets/fonts/poppinsextrabold.ttf");
}
@font-face {
  font-family: opensanslight;
  src: url("./assets/fonts/opensanslight.ttf");
}
@font-face {
  font-family: opensansregular;
  src: url("./assets/fonts/opensansregular.ttf");
}
@font-face {
  font-family: opensanssemibold;
  src: url("./assets/fonts/opensanssemibold.ttf");
}
@font-face {
  font-family: opensansbold;
  src: url("./assets/fonts/opensansbold.ttf");
}
@font-face {
  font-family: opensansextrabold;
  src: url("./assets/fonts/opensansextrabold.ttf");
}
@font-face {
  font-family: robotoregular;
  src: url("./assets/fonts/robotoregular.ttf");
}
@font-face {
  font-family: robotomedium;
  src: url("./assets/fonts/robotomedium.ttf");
}
.mainfont {
  font-family: Poppins, sans-serif;
}
a {
  text-decoration: none !important;
}

/* width */
::-webkit-scrollbar {
  width: 5px !important;
  height: 10px !important;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px grey !important;
  border-radius: 5px !important;
}

/* Handle */
::-webkit-scrollbar-thumb {
  /* background: #919191 !important; */
  background: #cd9f58 !important;
  border-radius: 5px !important;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
.v-text-field--outlined,
.v-text-field--solo {
  border-radius: 0px !important;
}
.v-text-field--outlined {
  border-radius: 0px !important;
}
</style>